import styled from 'styled-components'

export const TourWrapper=styled.div`
`